import { HeroCarousel } from "../components/HeroCarousel";
import { heroSlides } from "../data/content";

export function Hero() {
	return (
		<header className="hero-full" id="top">
			<div className="hero-full__media">
				<HeroCarousel slides={heroSlides} interval={12000} />
			</div>
			<div className="hero-full__content">
				<div className="hero-full__eyebrow">En memoria</div>
				<h1 className="hero-full__name">Stefanny Daniela Mora Nieto</h1>
				<div className="hero-full__dates">
					1 de septiembre, 1992 — 26 de septiembre, 2023
				</div>
				<p className="hero-full__tagline">
					Activista, poeta y luchadora por los derechos de la mujer. Que la luz y
					el fuego de su vida continúen a través de quienes la amábamos y
					compartíamos su visión.
				</p>
			</div>
			<div className="hero-full__scroll-hint">Desliza</div>
		</header>
	);
}
